import { Container } from "@mui/material";
import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import React, { useCallback, useEffect, useRef } from "react";
import Panel from "../../../../../components/Panel";
import {
  ContainerButton,
  Input,
  TextTitle,
  Title,
} from "../../../../../styles/global";
import Grid from "@mui/material/Unstable_Grid2";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faX } from "@fortawesome/free-solid-svg-icons";
import useInstanciaProtocolo from "../../../../../actions/cruds/Protocolo/useInstanciaProtocolo";
import { useAuth } from "../../../../../hooks/auth";
import getPermission from "../../../../../utils/getPermission";

const InstanciaProtocoloEdit: React.FC = () => { 
  const { instanciaId } = useParams();
  const { instanciaProtocolo, getInstanciaProtocolo, updateInstanciaProtocolo } = useInstanciaProtocolo();

  const { login } = useAuth();
  const protocoloPermission = getPermission(login,"Protocolo");
  const isVisitante = protocoloPermission == "Visitante";

  useEffect(() => {
    getInstanciaProtocolo(instanciaId);
  }, []);

  useEffect(() => {
    formRef.current?.setFieldValue("nome", instanciaProtocolo?.nome)
  }, [instanciaProtocolo])

  const formRef = useRef<FormHandles>(null);

  const handleSubmit = useCallback(async (data: object) => {
    try {
      console.log("data", data);
      updateInstanciaProtocolo(instanciaId, data);

    } catch (err) {
      console.log(err);      
    }
  }, []);

  return (
    <div>
      {
        isVisitante ? <>Você não tem permissão para acessar esse módulo.</> :

    <Container>
      <Title>
        <span>Editar Instância do Protocolo</span>
      </Title>

      <Form id="form1" ref={formRef} onSubmit={handleSubmit}>
        <Panel titulo="Instância">
          <Grid container spacing={6}>
            <Grid xs={12}>
              <TextTitle>Nome:</TextTitle>
              <Input type="text" name="nome" />
            </Grid>
          </Grid>
        </Panel>
        <ContainerButton>
          <Link to="/protocolo/cadastros/instancia">
            <button>
              <FontAwesomeIcon icon={faX} size="1x" /> Cancelar
            </button>
          </Link>
          <button type="submit" form="form1">
            <FontAwesomeIcon icon={faSave} /> Salvar
          </button>
        </ContainerButton>
      </Form>
    </Container>
      }
    </div>
  );
};

export default InstanciaProtocoloEdit;
